import React, { useEffect, useRef, useState } from "react";
import { ENDPOINTS } from "../../../js/api/_config";
import axios from "axios";

const ImageUploaderUrl = ({
  selectedImage,
  setSelectedImage,
  uploadStatus,
  setUploadStatus,
  isLoading,
  setIsLoading,
  fileUploadData,
  setFileUploadData,
  index,

}) => {
  const [previewUrl, setPreviewUrl] = useState(null);
  const [fileName, setFileName] = useState(""); // Store the file name
  const fileInputRef = useRef(null); // Reference to the file input element
  const [currImg, setCurrImg] = useState();

  const handleUploadSubmit = async (file) => {
    if (!file) return;
    setIsLoading(true);
    setUploadStatus("");

    const formData = new FormData();
    formData.append("ProfileImage", file);
        setFileUploadData(formData);
  };


  const handleImageChange = (event) => {
    const file = event.target.files[0];
   
    if (file) {
      setSelectedImage(file); // Store the actual file for uploading
      setPreviewUrl(URL.createObjectURL(file)); // Generate and set the preview URL
      setFileName(file.name);
      handleUploadSubmit(file)
    }
  
  };

  const handleRemoveImage = () => {
    setSelectedImage(null);
    setUploadStatus("");
    if (previewUrl) {
      URL.revokeObjectURL(previewUrl); // Revoke the object URL to free memory
      setPreviewUrl(null);
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Reset the file input value
    }
    setFileName(""); // Clear the file name
  };

  const triggerFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); // Trigger the file input's click event
    }
  };

  useEffect(() => {
    // Cleanup preview URL on component unmount
    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);

  function transcate(str, length) {
    if (str.length > length) {
      return str.slice(0, length) + '...';
    }
    return str;
  }

  // useEffect(() => {
  //   if (selectedImage) {
  //     handleUploadSubmit(); // Automatically upload when an image is selected
  //   }
  // }, [selectedImage]);

  return (
    <div className="block w-full p-2 px-0 pt-0">
      <div className="relative flex">
        <label class="form_label_color mb-3">Image </label>
        {previewUrl && (
          <div className="flex relative ml-10">
            <img
              src={previewUrl}
              alt="Preview"
              className="w-10 h-10 rounded-lg border"
            />
            <button
              type="button"
              onClick={handleRemoveImage}
              className="absolute w-6 h-6 flex justify-center items-center -top-2 left-7 bg-red-500 text-white rounded-full p-1 shadow hover:bg-red-600"
            >
              ✕
            </button>
          </div>)}
      </div>


      {/* Hidden File Input */}
      <input
        type="file"
        accept="image/*"
        onChange={handleImageChange}
        ref={fileInputRef}
        className="hidden"
      />

      {/* Custom Upload Button and File Name */}
      <div className="flex items-center space-x-2 border_color border text-base rounded-lg w-full p-2.5 pl-0 h-12">
        <button
          type="button"
          onClick={triggerFileInput}
          className="px-2 pl-0 py-2 w-[130px] text-[#373737] font-medium rounded-lg focus:outline-none"
        >
          Choose File
        </button>

        <span className="text-gray-700 text-sm truncate">{fileName ? transcate(fileName, 30) : "No file chosen"}</span>

      </div>
    </div>
  );
};

export default ImageUploaderUrl;
